import React, {useState} from 'react';
import {Link, useHistory} from 'react-router-dom';
import {Formik, FormikProps} from 'formik';

import paths from '@paths';
import utils from '@utils';
import {Button, Loader, Modal} from '@components';
import {Props} from './types';
import * as hooks from './hooks';
import * as handlers from './handlers';

import './index.scss';

const Confirm: React.FC<Props> = props => {
  const [usersCount, setUsersCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [cardInfo, setCardInfo] = useState<any>({last4: ''});
  const [isModal, setIsModal] = useState(false);
  const [isFaildModal, setIsFaildModal] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const routeState: any = props.location.state;
  let planDetail: any = {
    label: '',
    value: 0,
    price: 0,
  };

  planDetail = routeState
    ? utils.mappings.getPlan(routeState.plan)
    : {
        label: '',
        value: 0,
        price: 0,
      };
  const history = useHistory();

  const initialValues = {empty: ''};

  hooks.useMount(props.me, planDetail, setUsersCount, setLoading, setCardInfo);

  return (
    <div className="a__option-confirm">
      <div className="b__title">
        <Button.GoBack history={props.history} />
        決済の確認
      </div>
      <div className="b__confirm-card">
        <div className="b__plan-title">
          <div className="b__plan-name">{planDetail.label}</div>
          <div className="b__price">{planDetail.price}</div>
          <div className="b__asterisk">*</div>
          <div className="b__term">
            &nbsp; 円&nbsp;/&nbsp;月&nbsp;×&nbsp;{!loading && usersCount}人
          </div>
        </div>
        <div className="b__alert">
          <div className="b__asterisk">*</div>
          <div>登録済みのユーザー1人あたりの料金</div>
        </div>
        <div className="w__credit-card">
          <div className="w__customer-infomation">
            <div className="b__payment-title">支払情報</div>
            {cardInfo && (
              <div className="b__card-number">{`XXXX XXXX XXXX ${cardInfo.last4}`}</div>
            )}
          </div>

          <Link to={paths.myPage.card}>別のクレジットカードで支払う</Link>
        </div>
        <Formik
          initialValues={initialValues}
          onSubmit={() => {}}
          enableReinitialize
        >
          {(formPorps: FormikProps<any>) => {
            return (
              <>
                <div className="w__total">
                  <div className="b__total-title">合計</div>
                  {loading ? (
                    <div className="w__loader">
                      <Loader active={loading} />
                    </div>
                  ) : (
                    <div className="b__total">
                      {`${Number(
                        planDetail.price * usersCount
                      ).toLocaleString()}`}
                      &nbsp;円
                    </div>
                  )}
                </div>
                <div className="b__confirm-button">
                  <Button.Normal
                    rounded
                    color="yellow"
                    text="プランを変更する"
                    onClick={() => setIsModal(true)}
                    // カード削除後、ブラウザバックなどで表示された時にボタンを押せないようにする
                    disabled={formPorps.isSubmitting || !cardInfo}
                    loading={formPorps.isSubmitting}
                  />
                </div>
                <Modal.ChangePlan
                  isModal={isModal}
                  handleCloseModal={setIsModal}
                  planDetail={planDetail}
                  loading={submitting}
                  isForceCanceled={props.me.isForceCanceled}
                  onClick={async (value: any) =>
                    await handlers.submit(
                      value,
                      setSubmitting,
                      props.history,
                      props.me,
                      props.actions,
                      planDetail,
                      setIsModal,
                      setIsFaildModal
                    )
                  }
                />
                <Modal.Normal
                  title="決済の失敗"
                  size="xs"
                  isModal={isFaildModal}
                  message="無料プランへの変更を行いましたが、決済に失敗しました。カード変更後、再度決済をお願いします。"
                  handleCloseModal={setIsModal}
                  isAutoClose={false}
                  hideCloseIcon
                  buttonColor="yellow"
                  buttonText="カードを変更する"
                  hiddenCancelButton
                  onClick={() => {
                    history.push(paths.myPage.card);
                    props.actions.me.updateMe();
                  }}
                />
              </>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default Confirm;
